const oFeedSectionContent = {
  oFeedSectionContent: {
    alerts: {
      updateProductosOrdenar: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El orden de los productos fue actualizado exitosamente.'
      },
      updateProyectosOrdenar: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El orden de las formaciones fue actualizado exitosamente.'
      }
    }
  }
}

export default oFeedSectionContent
